export default __webpack_public_path__ + "static/media/slider_4-lg@2x.e65ba877.webp";